module.exports = __webpack_public_path__ + "static/img/cooperator.b64738f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/la_liga/cooperator.png
// module id = HMtQ
// module chunks = 1